// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement, cloneElement, isValidElement, Children } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './AuxiliaryActions.less';

/**
 * Auxiliary Actions component is used for executing additional (not primary) actions.
 * You should not use the actions for submitting data in Form.
 */
const AuxiliaryActions = ({ baseClassName, className, separator, children, ...props }) => {
    const separatorElement = separator === null ? <span className={`${baseClassName}__separator`}>{' | '}</span> : separator;

    return (
        <span className={classNames(baseClassName, className)} {...props}>
            {Children.toArray(children)
                .reduce((accu, elem, index) => accu === null
                    ? [elem]
                    : [...accu, isValidElement(separatorElement) ? cloneElement(separatorElement, { key: index }) : separator, elem], null)
            }
        </span>
    );
};

AuxiliaryActions.propTypes = {
    /**
     * Actions
     */
    children: PropTypes.node,
    /**
     * Custom separator between actions
     */
    separator: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

AuxiliaryActions.defaultProps = {
    baseClassName: `${CLS_PREFIX}auxiliary-actions`,
    className: null,
    separator: null,
    children: null,
};

export default AuxiliaryActions;



// WEBPACK FOOTER //
// ./components/AuxiliaryActions/AuxiliaryActions.js